<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout column class="eservice_inner_wrap">
      <h2 class="outside_title d-flex">
        {{ $t('myrequest.title') }}
        <v-spacer></v-spacer>
        <span class="loc_postion">
            <span class="front_loc">{{ $t('myrequest.title') }} > </span>
            <span class="back_loc">{{ $t('common.common.details') }}</span>
        </span>
      </h2>
      <v-layout column class="ma-0 pos-r center__wrapper mt-30">
        <v-flex class="inner_basic_wrap type2">
          <v-tabs
            class="my_app_tabs_data type2"
            hide-slider
            grow
          >
            <v-tab>{{ $t('myrequest.view.fields.request_data') }}</v-tab>
            <v-tab v-if="drawingCount > 0">{{ $t('myrequest.view.fields.drawings') }}</v-tab>
            <v-tab>{{ $t('myrequest.view.fields.attached_document') }}</v-tab>


            <v-tab-item>
              <v-layout class="mt-0">
                <ApplicationInformation
                  :receipt_no.sync = receipt_no
                />
              </v-layout>
              <v-flex class="item_box pa-0" style="border-bottom: none">
                <h2 class="m_title solo mt-35">{{ $t('myapplication.submitamendment.fields.type_of_amendment') }}</h2>
                <v-col cols="12" class="pa-0 mt-20">
                  <div class="input_checkbox_type_basic radio_dailog_type row ma-0 pl-15 pr-15">
                      <v-radio-group
                        row
                        v-model="indAmendedType"
                        class="view__radio"
                      >
                        <v-radio
                          key="Y"
                          :label="$t('myapplication.submitamendment.fields.reply_on_office_action_form')"
                          value="Y"
                          color="#a01c2a"
                          readonly
                        >
                        </v-radio>
                        <v-spacer class="hidden_lr10"></v-spacer>
                        <v-radio
                          key="N"
                          :label="$t('myapplication.submitamendment.fields.further_reply_form')"
                          value="N"
                          color="#a01c2a"
                          readonly
                        >
                        </v-radio>
                      </v-radio-group>
                  </div>
                </v-col>
              </v-flex>

              <v-flex class="item_box pa-0" style="border-bottom: none">
                <h2 class="m_title solo mt-35">{{ $t('myapplication.submitamendment.fields.egpo_decision_date') }}</h2>
                <v-row class="d-flex align-center pl-15 pr-15 pt-15">
                  <v-col cols="12" md="3" class="pb-0 ft-size12">
                    {{ amendDecisionDate }}
                  </v-col>
                </v-row>
              </v-flex>

              <v-flex class="item_box pa-0" style="border-bottom: none" v-show="indAmdAbstract == 'Y'">
                <h2 class="m_title solo mt-35">{{ $t('component.amended_biblio_details.abstract')  }}</h2>
                <v-row class="ma-0 mt-35">
                  <v-col cols="12" class="pb-0">
                    <div class="floating__title__self">{{ $t('common.button.before') }}</div>
                  </v-col>
                  <v-col cols="12" class="pt--10 d-flex align-center" style="border-top:1px solid #222;">
                    <v-row>
                      <v-col cols="12" md="1" class="d-flex align-center">
                        <label class="nec_title">{{ $t('component.amended_biblio_details.arabic')  }}</label>
                      </v-col>
                      <v-col cols="12" md="11">
                        <div class="input_text_type_basic wp100">
                          <v-textarea
                            dense
                            outlined
                            readonly
                            hide-details
                            class="ft-size12 arabic_align"
                            v-model="abstractAr"
                          >
                          </v-textarea>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" class="pt--10 d-flex align-center">
                    <v-row>
                      <v-col cols="12" md="1" class="d-flex align-center">
                        <label class="nec_title">{{ $t('component.amended_biblio_details.english')  }}</label>
                      </v-col>
                      <v-col cols="12" md="11">
                        <div class="input_text_type_basic wp100">
                          <v-textarea
                            dense
                            outlined
                            readonly
                            hide-details
                            class="ft-size12 text-left"
                            v-model="abstractEn"
                          >
                          </v-textarea>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row class="ma-0">
                  <v-col cols="12" class="pb-0">
                    <div class="floating__title__self ty2">{{ $t('common.button.after') }}</div>
                  </v-col>
                  <v-col cols="12" class="pt--10 d-flex align-center" style="border-top:1px solid #222;">
                    <v-row>
                      <v-col cols="12" md="1" class="d-flex align-center">
                        <label class="nec_title">{{ $t('component.amended_biblio_details.arabic')  }}</label>
                      </v-col>
                      <v-col cols="12" md="11">
                        <div class="input_text_type_basic wp100">
                          <v-textarea
                            dense
                            outlined
                            readonly
                            hide-details
                            class="ft-size12 arabic_align"
                            v-model="amendAbstractAr"
                          >
                          </v-textarea>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" class="pt--10 d-flex align-center">
                    <v-row>
                      <v-col cols="12" md="1" class="d-flex align-center">
                        <label class="nec_title">{{ $t('component.amended_biblio_details.english')  }}</label>
                      </v-col>
                      <v-col cols="12" md="11">
                        <div class="input_text_type_basic wp100">
                          <v-textarea
                            dense
                            outlined
                            readonly
                            hide-details
                            class="ft-size12 text-left"
                            v-model="amendAbstractEn"
                          >
                          </v-textarea>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-flex>

            </v-tab-item>

            <v-tab-item v-if="drawingCount > 0">
              <Drawings
                :receipt_no.sync="receipt_no"
                representative="N"
              />
            </v-tab-item>
            <v-tab-item>
              <DocumentViewer
                :items="documentFileList"
              />
            </v-tab-item>
          </v-tabs>

          <v-row class="d-block">
            <v-col cols="12" class="mt-40 d-flex">
              <v-spacer></v-spacer>
              <v-btn
                color="#a01c2a"
                dark
                min-width="150"
                min-height="50"
                class="btn-normal br_none"
                @click="fnGoList()"
              >{{ $t('common.button.go_to_list') }}</v-btn>
            </v-col>
          </v-row>
        </v-flex>
      </v-layout>

    </v-layout>
  </v-container>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import ApplicationInformation from '@/components/layout/ApplicationInformation'
import Drawings from '@/components/layout/Drawings'
import DocumentViewer from '@/components/layout/DocumentViewer'

export default {
  components :{
    ApplicationInformation,
    Drawings,
    DocumentViewer
  },
  data () {
    return {
      receipt_no : '',
      documentFileList: [],

      downloadUrl : process.env.VUE_APP_BASE_URL + '/file/download/',

      documents : [
        {
          user_document_config_seq : '',
          name_ar : '',
          name_en : '',
          spec_type_code : '',
          lang_type_code : '',
          user_document_seq : '',
          user_document_file_seq : '',
          document_file_key : '',
          document_file_name : '',
        }
      ],

      drawingCount: 0,
      indAmendedType: '',
      amendDecisionDate: '',

      indAmdAbstract: 'N',
      abstractAr: '',
      abstractEn: '',
      amendAbstractAr: '',
      amendAbstractEn: '',
    }
  },
  mounted(){
    window.scrollTo(0, 0)
    this.receipt_no = this.$route.params.receipt_no
    this.fnGetAmendment()
    this.fnGetDocumentFileList()
    this.fnGetDrawingList()
  },
  methods: {
    fnGetAmendment(){
      requestApi({
        url: '/receivings/amendment/' + this.receipt_no,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.indAmendedType = res.data.ind_amended_type
            this.amendDecisionDate = res.data.amend_decision_date
            this.indAmdAbstract = res.data.ind_amd_abstract
            this.abstractAr = res.data.abstract_ar
            this.abstractEn = res.data.abstract_en
            this.amendAbstractAr = res.data.amend_abstract_ar
            this.amendAbstractEn = res.data.amend_abstract_en
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetAmendment()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGoList() {
      let url = location.href
      let qryStr = url.split('?')[1]
      this.$router.push('/myrequest/list?' + qryStr)
    },

    fnGetDocumentFileList() {
      requestApi({
        url: '/receivings/'+ this.receipt_no +'/documents/files',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.documentFileList = res.data.list
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetDocumentFileList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGetDrawingList() {
      requestApi({
        url: '/receivings/' + this.receipt_no + '/drawings',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.drawingCount = res.data.list.length
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetDrawingList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

  }
}
</script>